if (!customElements.get('author-page-detail')) {
    class AuthorPageDetail extends HTMLElement {

        storeKey = undefined;
        authorHandle = undefined;

        loaddingView = undefined;
        errorView = undefined;
        contentViewWrapper = undefined;

        authorAvatarNode = undefined
        authorNameNode = undefined
        authorBioNode = undefined

        booksListWrapper = undefined

        constructor() {
            super()

            this.storeHost = this.dataset.host;
            this.storeKey = this.dataset.key;
            this.authorHandle = this.dataset.handle;

            this.loaddingView = this.querySelector('.author-loadding-wrapper');
            this.errorView = this.querySelector('.author-not-found');
            this.contentViewWrapper = this.querySelector('.author-content');

            this.authorAvatarNode = this.querySelector('#authorAvatarImg');
            this.authorNameNode = this.querySelector('#authorName');
            this.authorBioNode = this.querySelector('#authorBio');

            this.booksListWrapper = this.querySelector('.books-list');

            loadAuthorDetail(this.storeHost, this.storeKey, this.authorHandle, this.handleAuthorInfo.bind(this))
        }

        handleAuthorInfo(err, res) {
            this.loaddingView.style.display = 'none';
            if (err) {
                this.errorView.style.display = 'block';
                return;
            }
            this.errorView.style.display = 'none';
            this.contentViewWrapper.style.display = 'block';

            const { contributor, books = [] } = res

            this.authorAvatarNode.src = contributor.image || 'https://candlewick-press-us.imgix.net/missing-cover.jpg?dpr=2&q=100';
            this.authorAvatarNode.alt = contributor.name || 'Cover';
            this.authorNameNode.innerHTML = contributor.name || 'No Name';
            this.authorBioNode.innerHTML = contributor.description || 'No introduction available at the moment';

            let bookHtml = ''
            if (books && books.length > 0) {
                for(let i = 0; i < books.length; i++){
                    const book = books[i]
                    const val = `
                    <li class="book-item">
                        <div class="book-cover">
                            <img src="${book.cover || 'https://candlewick-press-us.imgix.net/missing-cover.jpg?dpr=2&q=100'}" alt="${book.title}">
                        </div>
                        <h3 class="book-title">${book.title}</h3>
                        <a href="/products/${book.shopifyHandle || book.shopifyId}" class="buy-link">View details</a>
                    </li>`
                    bookHtml+=val
                }
            } else {
                bookHtml = '<li>Empty</li>'
            }
            this.booksListWrapper.innerHTML = bookHtml
        }
    }
    customElements.define('author-page-detail', AuthorPageDetail);
}